import type { SxProps, Theme } from '@mui/material/styles';

import { Box } from 'ui/box';

import FunnelCardGrid from 'containers/user/critical-elements-monitoring/components/funnel-card-grid';
import FunnelCardSkeleton from 'containers/user/critical-elements-monitoring/components/funnel-card-skeleton';
import { FUNNEL_STAGE_COUNT } from 'containers/user/critical-elements-monitoring/monitoring-constants';

const TITLE_PLACEHOLDER_SX = [
  { width: '95px' },
  { width: '110px' },
  { width: '85px' },
  { width: '140px' },
] satisfies SxProps<Theme>[];

export interface FunnelCardRowSkeletonProps {
  cardCount?: number;
}

const FunnelCardRowSkeleton = ({
  cardCount = FUNNEL_STAGE_COUNT,
}: FunnelCardRowSkeletonProps) => (
  <Box role="status" data-testid="funnel-card-row-skeleton">
    <span className="sr-only">Loading funnel data</span>
    <div className="animate-pulse">
      <FunnelCardGrid>
        {Array.from({ length: cardCount }, (_, index) => (
          <FunnelCardSkeleton
            key={`funnel-card-skeleton-${index}`}
            titleSx={TITLE_PLACEHOLDER_SX[index % TITLE_PLACEHOLDER_SX.length]}
          />
        ))}
      </FunnelCardGrid>
    </div>
  </Box>
);

export default FunnelCardRowSkeleton;
